import {Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-cutout-rect',
  templateUrl: './cutout_rect.component.html',
})
export class CutoutRectComponent implements OnInit, OnChanges {
  @Input() width = 100;
  @Input() height = 100;
  @Input() content?: TemplateRef<any>;
  @Input() text?: string;
  @Input() cornerEdge = 0;
  @Input() strokeWidth = 2;
  @Input() frameColor = '#fff194';
  @Input() fontColor = '#fff194';
  @Input() fill = 'transparent';
  @Input() rotate = 0;

  points = this.computePoints();
  polyOffset = 5;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.points = this.computePoints();
  }

  private computePoints(): string {
    const x1 = this.cornerEdge + this.polyOffset;
    const y1 = this.cornerEdge + this.polyOffset;
    const x2 = this.width - this.cornerEdge + this.polyOffset;
    const y2 = this.height - this.cornerEdge + this.polyOffset;
    return `
      ${x1},${this.polyOffset} ${x2},${this.polyOffset} ${this.width + this.polyOffset},${y1} ${this.width + this.polyOffset},${y2} ${x2},${this.height + this.polyOffset} ${x1},${this.height + this.polyOffset} ${this.polyOffset},${y2} ${this.polyOffset},${y1}
    `;
  }

  get rotationString(): string {
    return `rotate(${this.rotate},${this.width / 2 + this.polyOffset},${this.height / 2 + this.polyOffset})`;
  }
}
